<style>

</style>

<template>
    <div class="animated fadeIn v-visitor-panel">

        <Request
                ref="requestDate"
                :onRequestSuccess="onRequestDateSuccess"
                root="/visitor-panel/date">
            <slot slot="body">
                <b-row>
                    <b-col>
                        <b-card>
                            <b-row>
                                <b-col sm="12" md="12" lg="12">
                                    <b-button @click="onTodayClick" variant="action" class="pull-left btn-square"><i class="fa fa-reply"></i>
                                    </b-button>
                                    <InputDatePicker
                                            class="pull-left"
                                            id="datePicker"
                                            :isInline="false"
                                            v-model="dataDatePicker"></InputDatePicker>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <DatePagination v-model="dataDate"></DatePagination>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>

                        <b-card no-body>
                            <div slot="header">
                                {{Core.Definition.getDefinition('Recherche')}}
                                <div v-b-toggle.searchForm class="card-header-actions">
                                    <b-link class="card-header-action btn-minimize">
                                        <i class="fa fa-chevron-down"></i>
                                    </b-link>
                                </div>
                            </div>

                            <b-collapse id="searchForm">
                                <b-card-body>
                                    <b-row>
                                        <b-col>
                                            <InputText
                                                    ref="id"
                                                    :label="Core.Definition.getDefinition('ID')"
                                                    v-model="dataSearch.userId"></InputText>
                                        </b-col>
                                        <b-col>
                                            <InputText
                                                    ref="firstname"
                                                    :label="Core.Definition.getDefinition('Prénom')"
                                                    v-model="dataSearch.userFirstname"></InputText>
                                        </b-col>
                                        <b-col>
                                            <InputText
                                                    ref="lastname"
                                                    :label="Core.Definition.getDefinition('Nom de famille')"
                                                    v-model="dataSearch.userLastname"></InputText>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <InputText
                                                    ref="email"
                                                    :label="Core.Definition.getDefinition('Courriel')"
                                                    v-model="dataSearch.userEmail"></InputText>
                                        </b-col>
                                        <b-col>
                                            <InputPhone
                                                    ref="phone"
                                                    :label="Core.Definition.getDefinition('Téléphone')"
                                                    v-model="dataSearch.userPhone"></InputPhone>
                                        </b-col>
                                        <b-col>
                                            <InputPhone
                                                    ref="mobile"
                                                    :label="Core.Definition.getDefinition('Mobile')"
                                                    v-model="dataSearch.userMobile"></InputPhone>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="text-right">
                                            <b-button-group class="btn-group-sm">
                                                <b-button @click="onResetSearchClick" class="btn btn-light">{{Core.Definition.getDefinition('Réinitialiser')}}</b-button>
                                                <b-button @click="onSearchClick" class="btn btn-info">{{Core.Definition.getDefinition('Rechercher')}}</b-button>
                                            </b-button-group>
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card>
                            <div slot="header">
                                {{Core.Definition.getDefinition('Visiteurs')}}
                            </div>
                            <b-row>
                                <b-col>
                                    <div v-if="dataBookings.length > 0" class="list-group">
                                        <EventBooking :completeDisplay="false" @onChange="onBookingChange" v-for="booking, bookingIndex in dataBookings" :booking="booking" :userActiveProducts="userActiveProducts(booking.userId)"></EventBooking>
                                    </div>
                                    <b-alert v-else show variant="light">
                                        {{Core.Definition.getDefinition('Aucune visite à afficher.')}}
                                    </b-alert>
                                </b-col>
                            </b-row>
                        </b-card>

                    </b-col>
                </b-row>

            </slot>
        </Request>

    </div>
</template>

<script>
    import Vue from 'vue'

    Vue.use(require('vue-moment'))
    import Request from '../../components/Request'
    import UserAction from '../../components/UserAction'
    import DatePagination from '../../components/DatePagination'
    import InputDatePicker from '../../components/InputDatePicker'
    import InputText from '../../components/InputText'
    import InputPhone from '../../components/InputPhone'
    import InputQuantity from '../../components/InputQuantity'
    import EventBooking from '../../components/EventBooking'

    export default {
        name: 'VisitorPanel',
        components: {
            Request,
            InputDatePicker,
            DatePagination,
            InputQuantity,
            UserAction,
            InputText,
            InputPhone,
            EventBooking
        },
        watch: {
            dataDate(val) {
                this.requestDate(val)
                this.dataDatePicker = Core.Value.encode(val, 'datePicker')
            },
            dataDatePicker(val) {
                val = Core.Value.decode(val, 'datePicker')
                this.dataDate = val
            }
        },
        mounted() {
            this.requestDate(this.dataDate)
        },
        data: function () {
            return {
                Core: window.Core,
                dataDatePicker: new Date(),
                dataDate: Vue.moment().format('YYYY-MM-DD'),
                dataBookings: [],
                dataActivePurchases: [],
                dataSearch: {
                    userId:'',
                    userLastname: '',
                    userFirstname:'',
                    userEmail: '',
                    userPhone: '',
                    userMobile: ''
                }
            }
        },
        computed: {
        },
        methods: {
            onTodayClick() {
                this.dataDate = Vue.moment().format('YYYY-MM-DD')
            },
            requestDate(date) {
                this.$refs.requestDate.addArg('date', date)
                this.$refs.requestDate.request()
            },
            onRequestDateSuccess(data) {
                this.dataBookings = []
                if (data.bookings !== undefined) {
                    this.dataBookings = data.bookings
                }

                this.dataActivePurchases = []
                if (data.activePurchases !== undefined) {
                    this.dataActivePurchases = data.activePurchases
                }
            },
            onResetSearchClick() {
                this.dataSearch = {
                    userId:'',
                    userLastname: '',
                    userFirstname:'',
                    userEmail: '',
                    userPhone: '',
                    userMobile: ''
                }
            },
            onSearchClick() {
            },
            onBookingChange(booking) {
                this.calcBookingRemaining(booking)
            },
            userActiveProducts(userId) {
                for (let activeProducts in this.dataActiveProducts) {
                    activeProducts = this.dataActiveProducts[activeProducts]
                    if (activeProducts.userId === userId) {
                        return activePurchases
                    }
                }
                return false
            },
            calcBookingRemaining(booking) {
                let bookingPurchaseType = ''
                let bookingLimit = 0

                if (Core.Validation.isId(booking.limitedSubscriptionId)) {
                    bookingPurchaseType = Core.Product.typeLimitedSubscription
                    bookingLimit = booking.limitedSubscriptionBookingLimit
                }

                if (Core.Validation.isId(booking.recurringSubscriptionId)) {
                    bookingPurchaseType = Core.Product.typeRecurringSubscription
                    bookingLimit = booking.recurringSubscriptionBookingLimit
                }

                let bookingCount = 0

                for(let bookingIndex in this.dataBookings) {
                    switch(bookingPurchaseType) {
                        case Core.Product.typeLimitedSubscription:
                            if (this.dataBookings[bookingIndex].limitedSubscriptionId === booking.limitedSubscriptionId) {
                                bookingCount += parseInt(this.dataBookings[bookingIndex].quantity)
                            }
                            break
                        case Core.Product.typeRecurringSubscription:
                            if (this.dataBookings[bookingIndex].recurringSubscriptionId === booking.limitedSubscriptionId) {
                                bookingCount += parseInt(this.dataBookings[bookingIndex].quantity)
                            }
                            break
                    }
                }

                let bookingRemaining = bookingLimit - bookingCount
                for(let bookingIndex in this.dataBookings) {
                    switch(bookingPurchaseType) {
                        case Core.Product.typeLimitedSubscription:
                            if (this.dataBookings[bookingIndex].limitedSubscriptionId === booking.limitedSubscriptionId) {
                                this.dataBookings[bookingIndex].limitedSubscriptionBookingRemaining = bookingRemaining
                            }
                            break
                        case Core.Product.typeRecurringSubscription:
                            if (this.dataBookings[bookingIndex].recurringSubscriptionId === booking.limitedSubscriptionId) {
                                this.dataBookings[bookingIndex].recurringSubscriptionBookingRemaining = bookingRemaining
                            }
                            break
                    }
                }
            }
        }
    }
</script>
